module.exports = __webpack_public_path__ + "static/media/hyerica_logo.3dfed884.png";